import { emsApi } from '@/api/emsApi';
import type { EmsComponents } from '@ngsos/portal-core/api/ems';
import { normalizeIncidentListItem } from '@ngsos/portal-core/realtime';
import type { IncidentListItem } from '@ngsos/portal-core/realtime';

export type { IncidentListItem };
export type GetIncidentsRequest =
  EmsComponents['schemas']['GetIncidentsRequest'];

export async function getIncidents(body: GetIncidentsRequest): Promise<IncidentListItem[]> {
  const { data, response } = await emsApi.POST('/portal/v1/incidents', { body });
  if (data === undefined) {
    throw new Error(`Failed to load incidents (HTTP ${response.status})`);
  }
  return data.map(normalizeIncidentListItem);
}
